import { type SelectProps, styled } from '@mui/material';

import { BaseSelect } from './base-select';

export const StyledSelect = styled(({ className, ...props }: SelectProps) => (
  <BaseSelect
    {...props}
    MenuProps={{
      slotProps: {
        paper: { className, ...props.MenuProps?.slotProps?.paper },
        ...props.MenuProps?.slotProps,
      },
      MenuListProps: {
        autoFocusItem: false,
        ...props.MenuProps?.MenuListProps,
      },
      ...props.MenuProps,
    }}
  />
))({
  marginTop: '4px',
  width: 'unset',
  '&.MuiMenu-paper': {
    border: '1px solid #B1B8BF',
    borderRadius: '4px',
    paddingRight: '0px',
    width: 'unset',
    boxShadow: '0 2px 8px 0 rgba(78, 80, 84, 0.16)',
  },

  '& .MuiMenu-list': {
    paddingTop: 0,
    paddingBottom: 0,
  },

  '& .MuiMenuItem-root': {
    margin: 0,
    paddingLeft: '8px',
    paddingRight: '8px',
    borderRadius: 0,
    height: 40,
    fontSize: 13,

    '&:hover': {
      backgroundColor: '#E8EAEC',
      '&.Mui-selected': {
        backgroundColor: '#E8EAEC',
      },
    },

    '&.Mui-focusVisible': {
      backgroundColor: '#E8EAEC',
    },
    '&.Mui-disabled': {
      color: '#B1B8BF',
      opacity: 1,
    },

    '&.Mui-selected': {
      backgroundColor: '#E8EAEC',
    },
  },
});
